import { Link } from "react-router-dom";
import { ArrowLeft, ShieldAlert } from "lucide-react";

const LegalPage = ({ title, children }) => (
  <div className="container-x py-12 sm:py-16 max-w-3xl">
    <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
      <ArrowLeft className="h-4 w-4" /> Torna alla home
    </Link>
    <h1 className="mt-4 text-3xl sm:text-4xl font-semibold tracking-tight">{title}</h1>
    <div className="mt-8 space-y-6 text-sm text-muted-foreground leading-relaxed">{children}</div>
  </div>
);

const H = ({ children }) => <h2 className="text-lg font-semibold text-foreground">{children}</h2>;

export default function UsoLecito() {
  return (
    <LegalPage title="Uso Lecito e Consenso">
      <div className="flex items-start gap-3 rounded-2xl border border-amber-500/40 bg-amber-500/10 p-4">
        <ShieldAlert className="h-5 w-5 text-amber-500 shrink-0 mt-0.5" />
        <p className="text-foreground">Il software di monitoraggio deve essere utilizzato esclusivamente in modo legale. L'uso improprio può costituire reato.</p>
      </div>
      <p>controllatelefoni.it fornisce strumenti di monitoraggio destinati a finalità legittime, quali il <strong className="text-foreground">controllo parentale</strong> sui minori e il monitoraggio di dispositivi di proprietà dell'acquirente.</p>
      <div className="space-y-2"><H>Quando è consentito</H><p>L'utilizzo è lecito quando:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>monitori un dispositivo di tua proprietà;</li>
          <li>controlli il dispositivo di un figlio minorenne sotto la tua tutela legale;</li>
          <li>hai ottenuto il consenso esplicito e documentabile dell'utilizzatore adulto del dispositivo.</li>
        </ul>
      </div>
      <div className="space-y-2"><H>Quando è vietato</H><p>È severamente vietato installare o utilizzare il servizio su dispositivi di terzi (es. partner, dipendenti o altri adulti) senza il loro consenso. Tali condotte possono violare la normativa sulla privacy e il codice penale.</p></div>
      <div className="space-y-2"><H>Responsabilità dell'utente</H><p>Il cliente è l'unico responsabile dell'uso del servizio e si impegna a rispettare tutte le leggi applicabili. controllatelefoni.it declina ogni responsabilità per usi illeciti.</p></div>
      <p>Accettando le condizioni durante l'acquisto, dichiari di aver compreso e di rispettare quanto sopra. Per dubbi consulta i <Link to="/termini" className="text-accent underline">Termini</Link> o contattaci.</p>
    </LegalPage>
  );
}
